export default "__VITE_ASSET__CkkLqIUe__"